module.exports = __webpack_public_path__ + "static/PlayfairDisplay-Black.7b98c94e.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/fonts/Playfair_Display/PlayfairDisplay-Black.ttf
// module id = 145
// module chunks = 4